import { FText } from '@fantaskticedtechlimited/fui-complib'
import { FFontTypes } from '@fantaskticedtechlimited/fui-fontlib'
import { Outlet } from 'react-router-dom'
import QBSelectDropDown from '../../Components/QBSelectDropDown'
import { useUserSettingContext } from '../../contexts/userSettingContext'
import { PageContainer } from '../../layout/PageContainer'

function QBArchitecture() {
    const { currentUserSetting } = useUserSettingContext()
    if (!currentUserSetting.questionBank) {
        return (
            <PageContainer
                header={
                    <FText
                        font={FFontTypes.Large_Text()}
                        children="QuestionBank Architecture"
                    />
                }
                body={
                    <>
                        <FText font={FFontTypes.Title()}>
                            Select Question Bank:
                        </FText>
                        <QBSelectDropDown />
                    </>
                }
            />
        )
    }
    return <Outlet />
}

export default QBArchitecture
